import React, { useContext } from 'react';
import useTranslatedOptions from '@ubeya/shared/hooks/useTranslatedOptions';
import { ContextMenu } from '@ubeya/shared-web/components';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';

const WageActionRenderer = ({
  rowData,
  rowData: { id, wageStatus, positionId, isBaseWage },
  columnData: { handleDelete, handleAdd, handleEdit }
}) => {
  const { t } = useContext(ConfigContext);

  const options = useTranslatedOptions([
    { label: t('edit'), onClick: () => handleEdit(rowData), visible: id },
    { label: t('delete'), onClick: () => handleDelete(rowData), visible: id },
    {
      label: t('add'),
      onClick: () => handleAdd({ positionId, isBaseWage }),
      visible: !wageStatus && (!!positionId || isBaseWage)
    }
  ]);

  return <ContextMenu options={options} usePortal />;
};

export default WageActionRenderer;
